<script setup lang="ts">
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';
import { useRouter } from 'vue-router';
const router = useRouter();

const goToLogin = () => {
  router.push({ name: 'ComLogin' });
};
</script>

<template>
  <main class="content">
    <h3>Account Activated</h3>
    <p class="description">
      Your account has been activated successfully. <br />You can now login to SolShare commissioning app.
    </p>
    <div class="button-container">
      <ButtonPrimary block @click="goToLogin">Login</ButtonPrimary>
    </div>
  </main>
</template>

<style lang="less" scoped>
@import '../../../assets/style/variables.less';

.description {
  margin-bottom: @margin-bottom-button;
  text-align: center;
}

.button-container {
  width: 100%;
  margin-top: @margin-top-end-of-page-section;
}
</style>